import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "basicParameter"
    }
  }, [_c("a-card", {
    staticStyle: {
      width: "1184px"
    },
    attrs: {
      bordered: false
    }
  }, [_c("a-form-model", {
    ref: "datavalue",
    staticClass: "form",
    attrs: {
      model: _vm.datavalue
    }
  }, [_c("a-row", {
    staticClass: "form-row",
    attrs: {
      gutter: 128
    }
  }, [_c("a-col", {
    attrs: {
      span: 16
    }
  }, [_c("a-form-model-item", {
    key: "first",
    attrs: {
      label: _vm.$t("productDetail.specFlag")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("public.pleaseSelect")
    },
    model: {
      value: _vm.datavalue.specFlag,
      callback: function callback($$v) {
        _vm.$set(_vm.datavalue, "specFlag", $$v);
      },
      expression: "datavalue.specFlag"
    }
  }, _vm._l(_vm.specFlagList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)], 1)], 1), _vm._l(_vm.datavalue.nameList, function (tempObj, index) {
    return [tempObj.required ? [_c("a-row", {
      staticClass: "form-row",
      attrs: {
        gutter: 128
      }
    }, [_c("a-col", {
      attrs: {
        span: 16
      }
    }, [_c("a-form-model-item", {
      attrs: {
        label: tempObj.titleName,
        prop: "nameList." + index + ".name",
        rules: [{
          required: true,
          message: _vm.errTip,
          trigger: "blur"
        }]
      }
    }, [_c("a-input", {
      attrs: {
        allowClear: true,
        placeholder: _vm.$t("public.enterPlease"),
        maxLength: 50,
        rows: 1
      },
      model: {
        value: tempObj.name,
        callback: function callback($$v) {
          _vm.$set(tempObj, "name", $$v);
        },
        expression: "tempObj.name"
      }
    })], 1)], 1)], 1)] : [_c("a-row", {
      staticClass: "form-row",
      attrs: {
        gutter: 128
      }
    }, [_c("a-col", {
      attrs: {
        span: 16
      }
    }, [_c("a-form-model-item", {
      key: "default",
      attrs: {
        label: tempObj.titleName
      }
    }, [_c("a-input", {
      attrs: {
        allowClear: true,
        placeholder: _vm.$t("public.enterPlease"),
        maxLength: 50,
        rows: 1
      },
      model: {
        value: tempObj.name,
        callback: function callback($$v) {
          _vm.$set(tempObj, "name", $$v);
        },
        expression: "tempObj.name"
      }
    })], 1)], 1)], 1)]];
  }), _c("a-row", {
    staticClass: "form-row",
    attrs: {
      gutter: 128
    }
  }), _c("a-row", {
    attrs: {
      gutter: 128
    }
  }, [_c("a-col", {
    attrs: {
      span: 8
    }
  }, [_vm._l(_vm.datavalue.classifies, function (item, index) {
    return [_c("a-form-model-item", {
      key: item.key,
      staticClass: "parent-opration",
      attrs: {
        label: index == 0 ? _vm.$t("productDetail.productCategory") : "",
        prop: "classifies." + index + ".value",
        rules: [{
          required: true,
          message: _vm.$t("public.pleaseSelect"),
          trigger: ["change", "blur"]
        }, {
          validator: _vm.validatecategory,
          trigger: "blur"
        }]
      }
    }, [_c("a-cascader", {
      key: item.key + "son",
      attrs: {
        options: _vm.classifyList,
        "field-names": {
          label: "categoryName",
          value: "id",
          children: "childrenList"
        },
        "change-on-select": "",
        placeholder: _vm.$t("public.pleaseSelect")
      },
      on: {
        popupVisibleChange: _vm.changeCategory,
        focus: function focus($event) {
          return _vm.focusCas(index);
        }
      },
      model: {
        value: item.value,
        callback: function callback($$v) {
          _vm.$set(item, "value", $$v);
        },
        expression: "item.value"
      }
    })], 1)];
  })], 2)], 1), _vm._l(_vm.datavalue.buyNotes, function (tempObj, index) {
    return [[_c("a-row", {
      key: index + "buy",
      staticClass: "form-row",
      attrs: {
        gutter: 128
      }
    }, [_c("a-col", {
      attrs: {
        span: 16
      }
    }, [_c("a-form-model-item", {
      key: index + "buy2",
      attrs: {
        label: tempObj.titleName
      }
    }, [_c("a-input", {
      attrs: {
        allowClear: true,
        placeholder: _vm.$t("public.enterPlease"),
        maxLength: 255,
        rows: 1
      },
      model: {
        value: tempObj.content,
        callback: function callback($$v) {
          _vm.$set(tempObj, "content", $$v);
        },
        expression: "tempObj.content"
      }
    })], 1)], 1)], 1)]];
  }), _c("footer-tool-bar", [_c("a-button", {
    attrs: {
      loading: _vm.queryLoading,
      type: "primary"
    },
    on: {
      click: _vm.saveData
    }
  }, [_vm._v(_vm._s(_vm.$t("public.save")) + " ")])], 1)], 2)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };